import React from 'react';
import { normalizeTagsArray } from '../utils/normalize';
import CustomTagInput from './CustomTagInput';

export default function DetailTagEditor({
  tags = [],
  onChange,
  suggestions = [],
  inputStyle = {},
  onTagClick = null,
  containerStyle = {},
}) {
  return (
    <div className="detail-tag-editor" style={{ maxWidth: '860px', margin: '0 auto 0.75rem', ...containerStyle }}>
      <CustomTagInput
        tags={tags}
        setTags={(next) => onChange?.(normalizeTagsArray(next))}
        suggestions={suggestions}
        style={{ width: '100%' }}
        inputStyle={{ ...inputStyle, width: '100%', boxSizing: 'border-box' }}
        onTagClick={onTagClick}
        layout="inline"
        showInputByDefault={false}
        addButtonLabel="+ Tag"
        addButtonClassName="detail-tag-add-btn"
        align="center"
        tagChipVariant="detail"
      />
    </div>
  );
}
